import React from "react"
import mount from "core/mount"
import Button from "@kit/design/button"
import Note from "@kit/design/note"

function UnconfirmedSendAddressBanner({ emailSettingsLink }) {
  // Inline style on Button was the least worst way to resolve cascade fighting
  // between the button component and the alert-warning style we're applying to
  // the banner container.
  return (
    <Note type="warning" className="items-center">
      <div className="flex flex-col md:flex-row gap-2 items-center justify-between">
        <p className="flex-grow mr-4">
          <strong>ACTION REQUIRED:</strong> Your account has email addresses
          that must be confirmed before they can be used in email sending. For
          more information, please review the{" "}
          <a
            href="https://help.convertkit.com/en/articles/4881660-why-is-my-sending-email-address-pending"
            className="text-blue-500 hover:text-gray-700"
          >
            Sending Address Confirmation FAQ
          </a>
          .
        </p>
        <Button
          color="light-yellow"
          href={emailSettingsLink}
          target="_blank"
          className="flex-shrink-0 font-semibold"
        >
          Manage Email Addresses
        </Button>
      </div>
    </Note>
  )
}
// TODO: once we fully rollout react_rendered_layout_sections, we can remove the mount call below

export { UnconfirmedSendAddressBanner }

mount({ "Account.UnconfirmedSendAddressBanner": UnconfirmedSendAddressBanner })
